import React, { useEffect, useState } from 'react';
import { useAuth } from '../models/AuthContext';
import adminSettingsService from '../models/AdminSettingsService';
import NetatmoAccountsManager from '../components/NetatmoAccountsManager';
import FirestoreInitializer from '../components/FirestoreInitializer';
import PageShell, { Btn, Pill } from '../components/design/PageShell';
import { Ic } from '../components/design/Icons';

const AdminNetatmo = () => {
  const { currentUser } = useAuth();
  const [tab, setTab] = useState('accounts');
  const [defaultStation, setDefaultStation] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const d = await adminSettingsService.getDefaultStation();
        setDefaultStation(d);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <PageShell
      section="admin / netatmo"
      number="09"
      title="Administration"
      subtitle="Intégrations, connecteurs et paramètres système"
    >
      <div className="eyebrow" style={{ marginBottom: 20 }}>§ 09.A · Intégrations</div>
      <section style={{
        display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 0,
        borderTop: '1px solid var(--rule)', borderLeft: '1px solid var(--rule)',
      }}>
        {[
          { id: 'accounts', name: 'Comptes Netatmo', desc: 'OAuth · Stations météo', status: 'actif', tone: 'ok' },
          { id: 'automower', name: 'Husqvarna Automower', desc: 'API v1 · robot tondeuse', status: 'actif', tone: 'ok' },
          { id: 'firestore', name: 'Firestore Initializer', desc: 'Structure base de données', status: 'configurable', tone: 'accent' },
        ].map((it, i) => (
          <article
            key={it.id}
            onClick={() => setTab(it.id)}
            style={{
              padding: 24, cursor: 'pointer',
              borderRight: '1px solid var(--rule)', borderBottom: '1px solid var(--rule)',
              background: tab === it.id ? 'var(--bg-1)' : 'transparent',
              borderLeft: tab === it.id ? '2px solid var(--accent)' : '2px solid transparent',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div className="mono" style={{ fontSize: 10, color: 'var(--ink-4)', letterSpacing: '0.18em' }}>INT-0{i + 1}</div>
              <Pill tone={it.tone}>{it.status}</Pill>
            </div>
            <div style={{ fontSize: 16, fontWeight: 500, letterSpacing: '-0.01em', margin: '28px 0 6px' }}>{it.name}</div>
            <div className="mono" style={{ fontSize: 11, color: 'var(--ink-3)', letterSpacing: '0.04em' }}>{it.desc}</div>
            <div style={{ marginTop: 24, paddingTop: 16, borderTop: '1px solid var(--rule)' }}>
              <span className="mono" style={{ color: tab === it.id ? 'var(--accent)' : 'var(--ink-3)', fontSize: 11, letterSpacing: '0.08em' }}>
                {tab === it.id ? 'actif →' : 'ouvrir →'}
              </span>
            </div>
          </article>
        ))}
      </section>

      <div className="eyebrow" style={{ marginTop: 56, marginBottom: 20 }}>§ 09.B · Détail · {tab === 'accounts' ? 'Comptes Netatmo' : tab === 'automower' ? 'Husqvarna' : 'Firestore'}</div>
      <section className="ta-admin-frame" style={{
        border: '1px solid var(--rule)', padding: 24, background: 'var(--bg-1)', minHeight: 200,
      }}>
        {tab === 'accounts' && <NetatmoAccountsManager />}
        {tab === 'automower' && (
          <div className="mono" style={{ color: 'var(--ink-3)' }}>
            Configuration Automower disponible via la page /admin/automower
          </div>
        )}
        {tab === 'firestore' && <FirestoreInitializer />}
      </section>

      <style>{`
        /* Dark theme overrides for embedded MUI components */
        .ta-admin-frame .MuiPaper-root,
        .ta-admin-frame .MuiCard-root {
          background: var(--bg-elev) !important;
          color: var(--ink) !important;
          border: 1px solid var(--rule) !important;
          box-shadow: none !important;
        }
        .ta-admin-frame .MuiTypography-root { color: var(--ink) !important; }
        .ta-admin-frame .MuiInputBase-input { color: var(--ink) !important; }
        .ta-admin-frame .MuiOutlinedInput-notchedOutline { border-color: var(--rule-2) !important; }
        .ta-admin-frame .MuiButton-root { color: var(--ink) !important; }
        .ta-admin-frame .MuiButton-contained { background: var(--accent) !important; color: var(--bg) !important; }
        .ta-admin-frame .MuiChip-root { background: var(--bg-2) !important; color: var(--ink-2) !important; border: 1px solid var(--rule-2) !important; }
      `}</style>
    </PageShell>
  );
};

export default AdminNetatmo;
